import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/_user/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/me' })
  },
})
